export enum SortByOrderingEnum {
	Asc = 'ASC',
	Desc = 'DESC',
}

export enum ReceivedRequestSortBy {
	UpdatedAt = 'UPDATED_AT',
	EmissionValue = 'EMISSION_VALUE',
}

export enum ProductEmissionRequestSortBy {
	UpdatedAt = 'UPDATED_AT',
	ReferenceNum = 'INTERNAL_REFERENCE',
	EmissionValue = 'EMISSION_VALUE',
}
export enum TemplateSortBy {
	UpdatedAt = 'UPDATED_AT',
	EmissionValue = 'EMISSION_VALUE',
}

export enum SupplierSortBy {
	Default = 'DEFAULT',
	ProductsConnected = 'PRODUCTS_CONNECTED',
}
export enum OrganisationInvitationSentSortBy {
	CreatedAt = 'CREATED_AT',
}

export enum QueryKey {
	GetAggregatedProductRequestAgeOverview,
	GetAggregatedProductRequestDataOverview,
	GetCurrentUser,
	GetCustomers,
	GetEmissionDataRequest,
	GetEmissionRequestDetails,
	GetEmissionRequestProductDetails,
	GetInvitedSuppliers,
	GetOwnOrganisation,
	GetPurchasedProducts,
	GetReceivedProductRequests,
	GetSBTISupplierStatistics,
	GetSBTItarget,
	GetSoldProducts,
	GetSupplier,
	GetSuppliers,
	GetTemplateDetails,
	ListAttachments,
	ListPendingUserInvites,
	ListReceivedInvitations,
	ListSentInvitations,
	ListSupplier,
	ListTemplates,
	ListUsers,
}
